export default {
  path: "/imagem",
  name: "Imagem",
  component: () => import("../pages/index.vue")
};
